<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" :size="size">
    <el-form-item class="select_btn_190" prop="deptLevelCodes">
        <el-input
          clearable
          placeholder="请选择工作单位"
          v-model="filters.deptNames"
          @focus="showDeptModal"
          @clear="clearDepts">
        </el-input>
      </el-form-item>
    <el-form-item label="学习时间：" class="m-l-14">
        <el-date-picker
            class="date-picker"
            value-format="yyyy-MM-dd"
            size="small"
            v-model="studyTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="changeStudyTime"
          >
          </el-date-picker>
    </el-form-item>
    <el-form-item>
     <el-checkbox
        :class="['checkbox_style', filters.isDirectly == 1 ? 'checkbox_active' : '']"
        v-model="filters.isDirectly"
        v-permission="'unitCredit:isDirectly'"
        :true-label="1"
        :false-label="0"
        class="drag-box"
        @change="changeDirectly"
        style="padding-right:10px"
      >40家省直单位</el-checkbox>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>

    <SearchLazyTree ref="lazyTree" :deptDialog="deptDialog" @selectDept="selectDept"/>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import SearchLazyTree from "@/components/tree/searchLazyTree.vue";
export default {
  name: "search",
  components: {
    butn, SearchLazyTree
  },
  props: ["placName"],
  data() {
    return {
      size: "small",
      deptDialog: {
        flag: false
      },
      studyTime: [],
      filters: {
        deptNames: "",
        isDirectly: 0,
      },
      defaultCheckedKeys: [],
      pickerOptions: {
        disabledDate: (time) => {
          let curDate = (new Date()).getTime()
          return time.getTime() > curDate;
        },
      },
      
    };
  },
  created() {
    this.initStudyTime();
  },
  methods: {
    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    // 选择工作单位弹窗
    showDeptModal() {
      this.deptDialog.flag = true;
    },
    clearDepts() {
      this.defaultCheckedKeys = [];
      this.filters.deptLevelCodes = [];
      this.$nextTick(()=> {
        this.$refs.lazyTree.$refs["tree"].setCheckedKeys(this.defaultCheckedKeys);
      })
    },
    // 工作单位选择确定
    selectDept(data) {
      this.filters.deptLevelCodes = data.deptLevelCodes;
      this.defaultCheckedKeys = data.nodeKeys;
      this.filters.deptNames = data.deptNames;
      if (data.deptLevelCodes && data.deptLevelCodes.length > 0) {
        this.filters.isDirectly = 0;
      }
      this.deptDialog.flag = false;
    },

    initStudyTime() {
      let nowDate = new Date();
      let year = nowDate.getFullYear() + '';
      let month = nowDate.getMonth();
      let day = nowDate.getDate();
      let studyTime = [`${year}-01-01`, `${year}-${month+1}-${day}`];
      this.studyTime = studyTime;
      this.changeStudyTime(studyTime);
      this.$emit("search", this.filters);
    },
    changeStudyTime(val) {
      this.filters.start = val[0];
      this.filters.end = val[1];
    },
    changeDirectly(val) {
      if (val == 1) {
        this.filters.deptLevelCodes = [];
        this.defaultCheckedKeys = [];
        this.filters.deptNames = '';
        this.$nextTick(()=> {
          this.$refs.lazyTree.$refs["tree"].setCheckedKeys(this.defaultCheckedKeys);
        })
      }
    },
    resetData() {
      this.filters = {
        deptNames: "",
        isDirectly: 0,
      };
      this.defaultCheckedKeys = [];
      this.$nextTick(()=> {
        this.$refs.lazyTree.$refs["tree"].setCheckedKeys(this.defaultCheckedKeys);
      })
      this.initStudyTime();
    },
  },
};
</script>

<style lang="scss" scoped>
.pro_input {
  width: 120px;
  margin-right: 10px;
}
.checkbox_style {
  border: 1px solid #dfe3e8;
  border-radius: 3px;
  padding-left: 10px;
  margin-right: 10px;
  &:hover {
    border: 1px solid #5c97df;
  }
}
.checkbox_active {
  border: 1px solid #5c97df;
}

</style>
